export { default as ProductInfoDS } from './product-info-ds'
export type { ProductInfoDSProps } from './product-info-ds'
